import React, { useState, useEffect, useLayoutEffect } from 'react';
import { BradcamArea } from '../../dumb/bradcam-area/BradcamArea';
import { GalleryArea } from '../../dumb/gallery-area/GalleryArea';
import { Footer } from '../../dumb/footer/Footer';
import { ProjectArea } from '../../dumb/project-area/ProjectArea';
import { TestForm } from '../../dumb/test-form/TestForm';
import { ScriptContainer } from '../../smart/script/ScriptContainer';
// import { ServiceSelector } from '../../smart/utils/images-loader/ServiceSelector';
import { Loader } from '../utils/loader/Loader';

type props = {}

export const MultipleServices = (props: any) => {

    //Hooks
    const [isOnline, setIsOnline] = useState(false);
    // var myLoader = ServiceSelector.select(props.filename);


    useLayoutEffect(() =>

        setIsOnline(true), [setIsOnline]
    );

    // useLayoutEffect(() =>

    //     console.log("sono single service ", props.contents)
    // );

    if (isOnline === false) {
        return <Loader />;
    }
    else {
        $('html, body').scrollTop(0)
        return <div>
            {/**bradcam area */}
            < BradcamArea {...props} title={props.contents.title} filename={props.filename}/>
            {/**gallery area component */}
            <GalleryArea {...props} contents={props.contents}  title={props.contents.title} filename={props.filename} myLoader={props.myLoader} clickhandler={props.clickhandler}/>
            {/**project area component */}
            <ProjectArea clickhandler={props.clickhandler}/>
            {/**footer area component */}
            <Footer clickhandler={props.clickhandler}/>
            {/**test form component */}
            <TestForm />
            {/**public scripts loader */}
            <ScriptContainer {...props} count={props.count} />
        </div>
    }
}